import { Stack } from '@chakra-ui/react'
import { ChakraPrimaryButton } from 'components/Button'
import AppointmentButton from 'containers/Dashboard/Dashboard/AppointmentButton'
import { Amplitude } from 'utils/amplitude.utils'
import { BookingEventSource, LabSchedulingSource } from 'utils/amplitude.types'

interface AppointmentNoteActionsProps {
  shouldShowCta: boolean
  labFastFollowsCta: boolean
  labsOrdered: boolean | undefined
  handleLegacyBookNextVisit: () => void
  hasUpcomingLabAppointment: boolean
}

/**
 * Legacy behavior for this component is to show a Book Next Visit button only if they have
 * met the conditions specified in the shouldShowCta prop.
 *
 * New behavior for this component is to show a Schedule Lab Work button if they have labs ordered and if they don't have an upcoming lab appointment
 * OR a Book Next Visit button if labs weren't ordered for them or if they have an upcoming lab appointment.
 * The Book Next Visit button is mapped to the same behavior as the always on button CTA.
 */
const AppointmentNoteActions = ({
  shouldShowCta,
  labFastFollowsCta,
  labsOrdered,
  handleLegacyBookNextVisit,
  hasUpcomingLabAppointment,
}: AppointmentNoteActionsProps) => {
  if (!labFastFollowsCta && shouldShowCta) {
    return (
      <ChakraPrimaryButton onClick={handleLegacyBookNextVisit}>
        Book next visit
      </ChakraPrimaryButton>
    )
  }

  return (
    <div>
      {labsOrdered && !hasUpcomingLabAppointment ? (
        <Stack display="flex" direction="column" gap={2} alignItems="flex-end">
          <AppointmentButton
            applyPrimaryStyle={true}
            appointmentLink={'/lab-schedule'}
            onClick={() =>
              Amplitude.labScheduleStart({
                source: LabSchedulingSource.APPOINTMENT_NOTE,
                is_reschedule: false,
              })
            }
          >
            Schedule Lab Work
          </AppointmentButton>
        </Stack>
      ) : (
        <Stack display="flex" direction="column" gap={2} alignItems="flex-end">
          <AppointmentButton
            applyPrimaryStyle={true}
            appointmentLink={`/schedule?source=${BookingEventSource.APPOINTMENT_NOTE}`}
          >
            Book Next Visit
          </AppointmentButton>
        </Stack>
      )}
    </div>
  )
}

export default AppointmentNoteActions
